export const USER_LIMIT = {
  ONE_TIME: 'one_time',
  MULTIPLE: 'multiple'
}
